export default __webpack_public_path__ + "static/media/t_instagram.7f190338.png";